//import { appUtils } from "../../../../utils/app.utils";


export const validateSearchForm = values => {
  const errors = {};
 
  if (!values.issuerNumber) {
    errors.issuerNumber = "Unable to search without an issuer selected"; 
  }
  if (values.cardProgram && !values.issuerNumber) {
    errors.issuerNumber = "Please select an issuer"; 
  }
//   if(appUtils.isEmptyObject(values)){
//     errors.pan = "Please enter a search criteria"
//     errors.firstName = "Please enter a search criteria"
//     errors.lastName = "Please enter a search criteria"
//   }
  return errors;
};
